import { combineReducers } from 'redux'
import entityOwnership from './entityOwnership'

export default combineReducers({
  entityOwnership
})
